import React, { useRef } from 'react';

function DataImportExport({ accounts, trades, setAccounts, setTrades }) {
  const fileInputRef = useRef(null);

  // 导出数据
  const exportData = () => {
    try {
      const data = { accounts, trades };
      const jsonString = JSON.stringify(data, null, 2);
      const blob = new Blob([jsonString], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'trading_data.json';
      document.body.appendChild(a);
      setTimeout(() => {
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        alert('数据导出成功！');
      }, 0);
    } catch (error) {
      alert('导出数据失败，请检查浏览器设置或稍后重试！');
    }
  };

  // 受控 input 方式导入数据，兼容移动端
  const handleImportClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    if (!window.FileReader) {
      alert('当前浏览器不支持文件导入，请更换浏览器！');
      return;
    }
    const file = event.target.files[0];
    if (!file) {
      alert('未选择文件！');
      return;
    }
    const reader = new FileReader();
    reader.onload = function(e) {
      try {
        const data = JSON.parse(e.target.result);
        if (!data.accounts || !Array.isArray(data.accounts) || !data.trades || !Array.isArray(data.trades)) {
          throw new Error('Invalid data format: accounts and trades must be arrays.');
        }
        // 验证账户数据格式
        data.accounts.forEach(account => {
          if (!account.name || typeof account.name !== 'string' ||
            !account.market || typeof account.market !== 'string' ||
            typeof account.capital !== 'number' || account.capital < 0 ||
            !account.currency || typeof account.currency !== 'string') {
            throw new Error('Invalid account data format.');
          }
        });
        // 验证交易数据格式
        data.trades.forEach(trade => {
          if (!trade.account || typeof trade.account !== 'string' ||
            !trade.date || typeof trade.date !== 'string' ||
            !trade.instrument || typeof trade.instrument !== 'string' ||
            typeof trade.size !== 'number' || trade.size <= 0 ||
            !trade.direction || typeof trade.direction !== 'string' ||
            typeof trade.entry !== 'number' || trade.entry <= 0 ||
            typeof trade.exit !== 'number' || trade.exit <= 0 ||
            typeof trade.fee !== 'number' || trade.fee < 0 ||
            typeof trade.profit !== 'number') {
            throw new Error('Invalid trade data format.');
          }
        });
        setAccounts(data.accounts);
        setTrades(data.trades);
        alert('数据导入成功！');
      } catch (error) {
        alert('导入数据失败：' + error.message);
      }
    };
    reader.onerror = function() {
      alert('读取文件失败，请稍后重试！\n错误信息: ' + (reader.error ? reader.error.message : '未知错误'));
    };
    reader.readAsText(file, 'utf-8');
  };

  return (
    <div className="section">
      <button onClick={exportData}>导出数据</button>
      {/* 用label包裹input，兼容移动端真实点击 */}
      <label style={{ display: 'inline-block', marginLeft: 8 }}>
        <button type="button" onClick={handleImportClick}>导入数据</button>
        <input
          type="file"
          accept=".json"
          style={{ display: 'none' }}
          ref={fileInputRef}
          onChange={handleFileChange}
        />
      </label>
    </div>
  );
}

export default DataImportExport; 